/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import MaterialProperty from './MaterialProperty';

/**
 * The MissionControllerDtoMissionFreeInfoDetailResponse model module.
 * @module model/MissionControllerDtoMissionFreeInfoDetailResponse
 * @version 1.0
 */
class MissionControllerDtoMissionFreeInfoDetailResponse {
    /**
     * Constructs a new <code>MissionControllerDtoMissionFreeInfoDetailResponse</code>.
     * @alias module:model/MissionControllerDtoMissionFreeInfoDetailResponse
     */
    constructor() { 
        
        MissionControllerDtoMissionFreeInfoDetailResponse.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>MissionControllerDtoMissionFreeInfoDetailResponse</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/MissionControllerDtoMissionFreeInfoDetailResponse} obj Optional instance to populate.
     * @return {module:model/MissionControllerDtoMissionFreeInfoDetailResponse} The populated <code>MissionControllerDtoMissionFreeInfoDetailResponse</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new MissionControllerDtoMissionFreeInfoDetailResponse();

            if (data.hasOwnProperty('resultCode')) {
                obj['resultCode'] = ApiClient.convertToType(data['resultCode'], 'Number');
            }
            if (data.hasOwnProperty('code')) {
                obj['code'] = ApiClient.convertToType(data['code'], 'String');
            }
            if (data.hasOwnProperty('description')) {
                obj['description'] = ApiClient.convertToType(data['description'], 'String');
            }
            if (data.hasOwnProperty('errorCode')) {
                obj['errorCode'] = ApiClient.convertToType(data['errorCode'], 'Number');
            }
            if (data.hasOwnProperty('contentsReward')) {
                obj['contentsReward'] = ApiClient.convertToType(data['contentsReward'], [MaterialProperty]);
            }
            if (data.hasOwnProperty('missionNo')) {
                obj['missionNo'] = ApiClient.convertToType(data['missionNo'], 'Number');
            }
            if (data.hasOwnProperty('beginAt')) {
                obj['beginAt'] = ApiClient.convertToType(data['beginAt'], 'Date');
            }
            if (data.hasOwnProperty('endAt')) {
                obj['endAt'] = ApiClient.convertToType(data['endAt'], 'Date');
            }
            if (data.hasOwnProperty('walletNo')) {
                obj['walletNo'] = ApiClient.convertToType(data['walletNo'], 'Number');
            }
            if (data.hasOwnProperty('dailyData')) {
                obj['dailyData'] = ApiClient.convertToType(data['dailyData'], 'String');
            }
            if (data.hasOwnProperty('achievementData')) {
                obj['achievementData'] = ApiClient.convertToType(data['achievementData'], 'String');
            }
            if (data.hasOwnProperty('conditionAt')) {
                obj['conditionAt'] = ApiClient.convertToType(data['conditionAt'], 'Date');
            }
            if (data.hasOwnProperty('createdAt')) {
                obj['createdAt'] = ApiClient.convertToType(data['createdAt'], 'Date');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>MissionControllerDtoMissionFreeInfoDetailResponse</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>MissionControllerDtoMissionFreeInfoDetailResponse</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['code'] && !(typeof data['code'] === 'string' || data['code'] instanceof String)) {
            throw new Error("Expected the field `code` to be a primitive type in the JSON string but got " + data['code']);
        }
        // ensure the json data is a string
        if (data['description'] && !(typeof data['description'] === 'string' || data['description'] instanceof String)) {
            throw new Error("Expected the field `description` to be a primitive type in the JSON string but got " + data['description']);
        }
        if (data['contentsReward']) { // data not null
            // ensure the json data is an array
            if (!Array.isArray(data['contentsReward'])) {
                throw new Error("Expected the field `contentsReward` to be an array in the JSON data but got " + data['contentsReward']);
            }
            // validate the optional field `contentsReward` (array)
            for (const item of data['contentsReward']) {
                MaterialProperty.validateJSON(item);
            };
        }
        // ensure the json data is a string
        if (data['dailyData'] && !(typeof data['dailyData'] === 'string' || data['dailyData'] instanceof String)) {
            throw new Error("Expected the field `dailyData` to be a primitive type in the JSON string but got " + data['dailyData']);
        }
        // ensure the json data is a string
        if (data['achievementData'] && !(typeof data['achievementData'] === 'string' || data['achievementData'] instanceof String)) {
            throw new Error("Expected the field `achievementData` to be a primitive type in the JSON string but got " + data['achievementData']);
        }

        return true;
    }


}



/**
 * @member {Number} resultCode
 */
MissionControllerDtoMissionFreeInfoDetailResponse.prototype['resultCode'] = undefined;

/**
 * @member {String} code
 */
MissionControllerDtoMissionFreeInfoDetailResponse.prototype['code'] = undefined;

/**
 * @member {String} description
 */
MissionControllerDtoMissionFreeInfoDetailResponse.prototype['description'] = undefined;

/**
 * @member {Number} errorCode
 */
MissionControllerDtoMissionFreeInfoDetailResponse.prototype['errorCode'] = undefined;

/**
 * @member {Array.<module:model/MaterialProperty>} contentsReward
 */
MissionControllerDtoMissionFreeInfoDetailResponse.prototype['contentsReward'] = undefined;

/**
 * @member {Number} missionNo
 */
MissionControllerDtoMissionFreeInfoDetailResponse.prototype['missionNo'] = undefined;

/**
 * @member {Date} beginAt
 */
MissionControllerDtoMissionFreeInfoDetailResponse.prototype['beginAt'] = undefined;

/**
 * @member {Date} endAt
 */
MissionControllerDtoMissionFreeInfoDetailResponse.prototype['endAt'] = undefined;

/**
 * @member {Number} walletNo
 */
MissionControllerDtoMissionFreeInfoDetailResponse.prototype['walletNo'] = undefined;

/**
 * @member {String} dailyData
 */
MissionControllerDtoMissionFreeInfoDetailResponse.prototype['dailyData'] = undefined;

/**
 * @member {String} achievementData
 */
MissionControllerDtoMissionFreeInfoDetailResponse.prototype['achievementData'] = undefined;

/**
 * @member {Date} conditionAt
 */
MissionControllerDtoMissionFreeInfoDetailResponse.prototype['conditionAt'] = undefined;

/**
 * @member {Date} createdAt
 */
MissionControllerDtoMissionFreeInfoDetailResponse.prototype['createdAt'] = undefined;






export default MissionControllerDtoMissionFreeInfoDetailResponse;

